import { useSelector } from "react-redux";
import Container from "../components/basicComponents/container";
import Grid from "../components/grid";
import { selectGlobalState } from "../state-management/selectors";
import { departmantGenerateColumns } from "../utils/generate-columns-departmants";
import { useRef, useEffect, useState } from "react";
import {
  addUserToDepartment,
  editUserDepartment,
  // removeGrouing,
  getAllGrouping,
} from "../state-management/actions/grouping-actions";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import { userGetAll } from "../state-management/actions/user-actions";
import { useDispatch } from "react-redux";
import { setGroupingData } from "../state-management/actions/global-state-actions";
import "../styles/disableCell.css";

export default function UserGrouping() {
  const { departmentsData } = useSelector(selectGlobalState);
  const dispatch = useDispatch();
  const [updateBox, setUpdateBox] = useState<boolean>(false);
  const [allGroup, setAllGroup] = useState<any>([]);
  const [groupData, setGroupData] = useState<any>([]);
  const [userData, setUserData] = useState<any>([]);
  const [updateFlag, setUpdateFlag] = useState<boolean>(true);
  const columns = departmantGenerateColumns(departmentsData);
  const departmentRef = useRef<string[]>([]);
  const userRef = useRef<string>("");

  const handleAlert = (status: boolean) => {
    if (status) {
      dispatch(setAlert(true));
      dispatch(setAlertSeverity("success"));
      dispatch(setAlertContext(" عملیات با موفقیت تکمیل شد"));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllGrouping()(dispatch);
        const data = await userGetAll()(dispatch);
        setAllGroup(response.data);
        setGroupData(
          response.data
            .map((item: any) => ({
              ...item,
              department_id: Array.from(
                new Set(
                  item.department_id?.filter((id: any) => id !== null) || []
                )
              ),
            }))
            .filter((item: any) => item.department_id.length > 1)
        );

        setUserData(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [updateFlag]);

  const userWithoutGroup = (data: any, userData: any) => {
    return userData.filter(
      (user: any) =>
        !data.some((groupingUser: any) => groupingUser.user_id === user._id)
    );
  };

  const usersWithoutGroup = userWithoutGroup(groupData, userData);

  // const handleDelete = async (id: string) => {
  //   try {
  //     const response = await removeGrouing(id)(dispatch);
  //     dispatch(
  //       setGroupingData(groupingData.filter((item: any) => item._id !== id))
  //     );
  //     console.log(response);
  //     handleAlert(true);
  //     setUpdateFlag((prev: any) => !prev);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleMethod = async () => {
    try {
      departmentRef.current = Array.from(
        new Set(
          departmentRef.current.filter(
            (id: any) => id !== null && id !== undefined
          )
        )
      );

      const userExist = allGroup.some(
        (data: any) => data.user_id === userRef.current
      );

      if (userExist) {
        const id = allGroup.find(
          (data: any) => data.user_id === userRef.current
        )?._id;
        await editUserDepartment(id, {
          department_id: departmentRef.current,
          description: "test",
        })(dispatch);
        const updatedGroupData = allGroup.map((data: any) =>
          data.user_id === userRef.current
            ? {
                ...data,
                department_id: departmentRef.current,
                description: "test",
              }
            : data
        );
        dispatch(setGroupingData(updatedGroupData));
        setUpdateFlag((prev: any) => !prev);
        handleAlert(true);
      } else {
        await addUserToDepartment({
          department_id: departmentRef.current,
          user_id: userRef.current,
          description: "test",
        })(dispatch);
        const newUser = {
          user_id: userRef.current,
          department_id: departmentRef.current,
          description: "test",
        };
        const updatedGroupData = [...allGroup, newUser];
        dispatch(setGroupingData(updatedGroupData));
        setUpdateFlag((prev: any) => !prev);
        handleAlert(true);
      }
      departmentRef.current = [];
    } catch (error) {
      console.log(error);
    }
  };

  const handleCellChange = (params: any) => {
    const departmentId = params.colDef.field;
    userRef.current = params.data.user_id;

    const userDeps = groupData.find(
      (dep: any) => userRef.current === dep.user_id
    )?.department_id;
    const mainDepartment = userData.find(
      (item: any) => item._id === params.data.userId
    )?.main_department;

    departmentRef.current = userDeps ? [...userDeps, mainDepartment] : [];

    if (!departmentRef.current.includes(departmentId)) {
      departmentRef.current = [
        ...departmentRef.current,
        departmentId,
        mainDepartment,
      ];
    } else {
      departmentRef.current = departmentRef.current.filter(
        (id) => id !== departmentId
      );
    }

    params.data.department_id = [...departmentRef.current, mainDepartment];
    dispatch(
      setGroupingData(
        groupData.map((item: any) =>
          item.user_id === userRef.current
            ? {
                ...item,
                department_id: [...departmentRef.current, mainDepartment],
              }
            : item
        )
      )
    );
  };

  const handleCellChangeWithoutGroup = (params: any) => {
    const departmentId = params.colDef.field;
    userRef.current = params.data._id;

    if (!departmentRef.current.includes(departmentId)) {
      departmentRef.current = [
        ...departmentRef.current,
        departmentId,
        params.data.main_department,
      ];
    } else {
      departmentRef.current = departmentRef.current.filter(
        (id) => id !== departmentId
      );
    }

    params.data.department_id = [
      ...departmentRef.current,
      params.data.main_department,
    ];
    console.log(updateBox);
    setUpdateBox((prev: any) => !prev);
  };
  const isCellDisabled = (departmentId: string, data?: any) => {
    const mainDep = userData.find(
      (item: any) => item._id === data?.user_id
    )?.main_department;
    return mainDep === departmentId;
  };

  const enhancedColumns = [
    {
      headerName: "نام و نام خانوادگی",
      valueGetter: (params: any) => {
        const user = userData.find(
          (user: any) => user._id === params.data.user_id
        );
        return user ? `${user.firstname} ${user.lastname}` : "نامشخص";
      },
      pinned: "right",
    },
    ...columns.map((column: any) => ({
      ...column,
      valueGetter: (params: any) => {
        const userMainDepartment = userData.find(
          (user: any) => user._id === params.data.user_id
        ).main_department;
        const userDepartments = [
          ...params.data.department_id,
          userMainDepartment,
        ];

        return userDepartments.includes(column.field);
      },
      cellRenderer: "agCheckboxCellRenderer",
      cellClassRules: {
        "disabled-cell": (params: any) =>
          isCellDisabled(params.colDef.field, params.data),
      },
    })),
  ];

  const userWhitoutGroupColumns = [
    {
      headerName: "نام و نام خانوادگی",
      valueGetter: (params: any) =>
        `${params.data.firstname} ${params.data.lastname}`,
      pinned: "right",
    },
    ...columns.map((column: any) => ({
      ...column,
      valueGetter: (params: any) => {
        let departmentIds = Array.isArray(params.data.department_id)
          ? params.data.department_id
          : [];
        if (
          params.data.main_department &&
          !departmentIds.includes(params.data.main_department)
        ) {
          departmentIds = [...departmentIds, params.data.main_department];
        }
        params.data.department_id = departmentIds;

        return departmentIds.includes(column.field);
      },
      cellRenderer: "agCheckboxCellRenderer",
      cellClassRules: {
        "disabled-cell": (params: any) =>
          params.data?.main_department === params.colDef.field,
      },
    })),
  ];

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <Container header="">
        <div className="flex flex-col gap-y-15 w-full">
          <h3 className="text-lg" style={{ margin: "30px 0 30px 0" }}>
            چند عضویتی
          </h3>
          <Grid
            height={400}
            columns={enhancedColumns}
            userData={groupData}
            pageSize={50}
            pagination={true}
            editBtn={true}
            deleteBtn={true}
            editable={true}
            btnHeader="عملیات"
            handleEdit={handleMethod}
            // handleDelete={handleDelete}
            onCellValueChanged={handleCellChange}
          />
          <span style={{ marginTop: "40px " }}></span>
          <hr />
          <h3
            className="text-lg borter-t-2 border-white border-solid	"
            style={{ margin: "25px 0 15px 0" }}
          >
            تک عضویتی
          </h3>

          <Grid
            height={400}
            columns={userWhitoutGroupColumns}
            userData={usersWithoutGroup}
            pageSize={50}
            pagination={true}
            editBtn={true}
            deleteBtn={true}
            editable={true}
            btnHeader="عملیات"
            handleEdit={handleMethod}
            onCellValueChanged={handleCellChangeWithoutGroup}
          />
        </div>
      </Container>
    </div>
  );
}
